import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/used-product/")({
  head: () => pageHead({ title: 'Used RVs', description: 'Shop used RVs for sale at Rex & Sons RVs near Wilmington, NC.', path: '/used-product' }),
  beforeLoad: () => {
    throw redirect({ href: "/rv-search?condition=used" });
  },
});